import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, unref as _unref, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "container-fluid" }
const _hoisted_2 = { class: "row" }

import { ref, defineAsyncComponent } from 'vue'

export default /*@__PURE__*/_defineComponent({
  __name: 'indexDropdown',
  setup(__props) {

const basicDropdown = defineAsyncComponent(() => import("@/components/theme/uikits/dropdown/basicDropdown.vue"))
const roundedDropdown = defineAsyncComponent(() => import("@/components/theme/uikits/dropdown/roundedDropdown.vue"))
const splitDropdown = defineAsyncComponent(() => import("@/components/theme/uikits/dropdown/splitDropdown.vue"))
const dropdownSection = defineAsyncComponent(() => import("@/components/theme/uikits/dropdown/dropdownSection.vue"))
const uniqueDropdown = defineAsyncComponent(() => import("@/components/theme/uikits/dropdown/uniqueDropdown.vue"))
const justifyContents = defineAsyncComponent(() => import("@/components/theme/uikits/dropdown/justifyContents.vue"))
const alignmentsDropdown = defineAsyncComponent(() => import("@/components/theme/uikits/dropdown/alignmentsDropdown.vue"))
const helperCard = defineAsyncComponent(() => import("@/components/theme/uikits/dropdown/helperCard.vue"))
const dividerDropdown = defineAsyncComponent(() => import("@/components/theme/uikits/dropdown/dividerDropdown.vue"))
const dropdownSizing = defineAsyncComponent(() => import("@/components/theme/uikits/dropdown/dropdownSizing.vue"))

return (_ctx: any,_cache: any) => {
  const _component_Breadcrumbs = _resolveComponent("Breadcrumbs")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_Breadcrumbs, {
      main: "Ui Kits",
      title: "Dropdown"
    }),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_unref(basicDropdown)),
        _createVNode(_unref(roundedDropdown)),
        _createVNode(_unref(splitDropdown)),
        _createVNode(_unref(dropdownSection)),
        _createVNode(_unref(uniqueDropdown)),
        _createVNode(_unref(justifyContents)),
        _createVNode(_unref(alignmentsDropdown)),
        _createVNode(_unref(helperCard)),
        _createVNode(_unref(dividerDropdown)),
        _createVNode(_unref(dropdownSizing))
      ])
    ])
  ], 64))
}
}

})